// extracted by mini-css-extract-plugin
export default {"price":"Ppa-z","onSale":"Qpa-z","msrpLabelPrice":"Rpa-z","msrpLabel":"Spa-z","originalPrice":"Tpa-z"};